function galleryCarousel() {

    jQuery(document).ready(function ($) {
        $('.image-gallery-slider').each(function () {
            const $swiperEl = $(this).find('.image-gallery-swiper')[0];
            if (!$swiperEl) return;

            const swiper = new Swiper($swiperEl, {
                slidesPerView: 'auto',
                loop: false,
                allowTouchMove: true,
                spaceBetween: 20,
            });

            const wrapper = swiper.wrapperEl;
            if (wrapper) {
                wrapper.innerHTML += wrapper.innerHTML;
                swiper.update();
            }

            let speed = .5;
            let paused = false;

            function animate() {
                if (!paused) {
                    let x = swiper.getTranslate() - speed;

                    const maxScroll = wrapper.scrollWidth / 2;

                    if (Math.abs(x) >= maxScroll) {
                        x = 0;
                    }

                    swiper.setTranslate(x);
                }

                requestAnimationFrame(animate);
            }

            animate();

            $($swiperEl).on('mouseenter', function () {
                paused = true;
            });

            $($swiperEl).on('mouseleave', function () {
                paused = false;
            });
        });
    });

}

export default galleryCarousel;